
<workflow-no-access [workflowTargetInfo]="workflowTargetInfo"></workflow-no-access>
<div class="container" [hidden]="!workflowTargetInfo.correctRole">
  <div class="row step-description-block">
    <div class="col">
      <div class="float-left">
        <p>
          Associate Standalone Assets. The following accessories are not associated to any asset. Please associate
          them to an asset in order to continue.
        </p>
      </div>
    </div>
  </div>
  <div class="row alert">
    <div class="col">
      <error [error]="error"></error>
    </div>
  </div>
  <div class="row">
    <div class="col table-card">
      <list-controls [search]="searchText" [limit]="pageSize" [page]="currentPage" [numPages]="maxPages" [totalCount]="totalCount" (onChange)="onListControlsChange($event)">
        <div class="dropdown">
          <button class="btn btn-primary dropdown-toggle" type="button" data-toggle="dropdown" [disabled]="isLocked">Add Assets</button>
          <div class="dropdown-menu dropdown-menu-right"><a class="dropdown-item" [href]="'#/workflow/' + workflowService.workflowConfig.id + '/addAssets/importCDF'" *ngIf="showImportCDF">Import CDF from SOLD</a><a class="dropdown-item" [downloadFile]="'/api/sites/export-assets/' + workflowTargetInfo.targetId" *ngIf="showManualDesign">Export Manual Design File</a><a class="dropdown-item" [uploadFileTo]="'/api/sites/import-assets/' + workflowTargetInfo.targetId" *ngIf="showManualDesign" [fileExtensions]="['xls', 'xlsx', 'xlsm', 'xlsb']" [title]="'Import Assets'">Import Manual Design File</a><a class="dropdown-item" [href]="'#/workflow/' + workflowService.workflowConfig.id + '/' + stepName + '/devices'" *ngIf="showAddIndividualAssets">Add Individual Assets</a><a class="dropdown-item" href="javascript:void(0);" (click)="showDartCorrectionDialog()">Request DART Correction</a></div>
        </div>
      </list-controls>
      <table class="table table-responsive">
        <thead>
          <tr class="table-header-with-controls">
            <th>SKU</th>
            <th>Description</th>
            <th>Device Key</th>
            <th>Bundle Number</th>
            <th>Serial Number</th>
            <th *ngIf="!isLocked">Actions</th>
          </tr>
        </thead>
        <tbody>
          <ng-template ngFor let-accessory [ngForOf]="unassociatedStandaloneAccessories">
            <tr>
              <td>{{ accessory.productNumber }}</td>
              <td>{{ accessory.friendlyName || accessory.description }}</td>
              <td>{{ accessory.deviceKey }}</td>
              <td>{{ accessory.bundleNumber }}</td>
              <td>{{ accessory.serialNumber }}</td>
              <td *ngIf="!isLocked">
                <div class="btn-group">
                  <button class="btn btn-outline-primary btn-sm" (click)="associate(accessory)" [disabled]="accessory.installed || accessory.ordered">Associate</button>
                </div>
              </td>
            </tr>
          </ng-template>
          <tr *ngIf="pendingAccessories === 0; else emptyResult">
            <td colspan="8">
              <p class="text-center empty-table-message">All accessories are associated, please proceed to the next step.</p>
            </td>
          </tr>
          <ng-template #emptyResult>
            <tr *ngIf="unassociatedStandaloneAccessories.length === 0">
              <td colspan="8">
                <p class="text-center empty-table-message">There are no assets to display</p>
              </td>
            </tr>
          </ng-template>
        </tbody>
      </table>
    </div>
  </div>
</div>